import React from 'react'
import { useDispatch } from 'react-redux';
import { makeStyles } from "@material-ui/core/styles";
import { Button, CircularProgress, Grid, TextField, Typography } from '@material-ui/core'
import DoneIcon from '@material-ui/icons/Done';
import ErrorIcon from '@material-ui/icons/Error';
import IAMAction from '../../actions/IAMAction';

const useStyles = makeStyles((theme) => ({
    rootDesktop: {
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(4),
        marginRight: theme.spacing(4),
    },
    rootTablet: {
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(5),
        marginRight: theme.spacing(5),
    },
    rootMobile: {
        marginTop: theme.spacing(1),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    root2: {
        marginLeft: theme.spacing(5),
    },
    button: {
        marginLeft: theme.spacing(25),
        width: 250
    },
    buttonMobile: {
        width: 250
    }
}));

const ResetPassword = ({ profile, responsive }) => {
    const classes = useStyles()
    const dispatch = useDispatch()

    const [currentPassword, setCurrentPassword] = React.useState("")
    const [newPassword, setNewPassword] = React.useState("")
    const [repassword, setRepassword] = React.useState("")

    const [resetStatus, setResetStatus] = React.useState(0)
    const [missing, setMissing] = React.useState({})
    const [passwordmatch, setPasswordmatch] = React.useState(-1)

    React.useEffect(() => { if (resetStatus === 4 && profile.force_password_reset === 1) dispatch({ type: 'SET_USER_DATA', value: { ...profile, force_password_reset: 0 } }) }, [resetStatus])

    const validateArgs = (args) => {
        let _missing = {}
        const keys = Object.keys(args)
        keys.map((key) => _missing[key] = args[key] === "")
        setMissing(_missing)
        let validated = false
        Object.keys(_missing).map((key) => {
            if (validated === false) {
                validated = _missing[key]
            }
        })
        return !validated
    }

    const onPaswordReset = () => {
        var args = {}
        args = {
            currentPassword: currentPassword.length >= 8 ? currentPassword : '',
            newPassword: newPassword.length >= 8 ? newPassword : '',
            repassword: repassword.length >= 8 ? repassword : ''
        }
        setPasswordmatch(newPassword === repassword ? 1 : 0)
        if (validateArgs(args) && newPassword === repassword) {
            IAMAction.password_reset(profile.username, currentPassword, newPassword, setResetStatus)
        }
    }

    return (
        <React.Fragment>
            <Grid container className={responsive.isDesktopOrLaptop ? classes.rootDesktop : responsive.isTablet ? classes.rootTablet : responsive.isMobile ? classes.rootMobile : classes.rootDesktop} direction="column" justify="flex-start" alignItems="flex-start" spacing={2}>
                <Grid item>
                    <Grid container direction="row" justify="center" alignItems="center" spacing={2}>
                        <Grid item style={{ minWidth: 150 }}><Typography variant="h4" color="textSecondary">Password reset</Typography></Grid>
                    </Grid>
                </Grid>
                {
                    responsive.isMobile ? (
                        <React.Fragment>
                            <Grid item>
                                <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={1}>
                                    <Grid item style={{ minWidth: 200 }}><Typography variant="h5" color="textSecondary">Current password:</Typography></Grid>
                                    <Grid item style={{ minWidth: 300 }}>
                                        <TextField variant='outlined' size='small' fullWidth type='password' value={currentPassword} error={missing['currentPassword']} onChange={(event) => setCurrentPassword(event.target.value)} />
                                    </Grid>
                                    {
                                        resetStatus === 1 ? (
                                            <React.Fragment>
                                                <Grid item><CircularProgress size={25} /></Grid>
                                                <Grid item>
                                                    <Typography variant='h5' color='textSecondary'>Encrypting...</Typography>
                                                </Grid>
                                            </React.Fragment>
                                        ) : resetStatus > 1 ? (
                                            <React.Fragment>
                                                <Grid item><DoneIcon color='primary' /></Grid>
                                                <Grid item>
                                                    <Typography variant='h5' color='textSecondary'>Encrypted</Typography>
                                                </Grid>
                                            </React.Fragment>
                                        ) : null
                                    }
                                </Grid>
                            </Grid>
                            <Grid item>
                                <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={1}>
                                    <Grid item style={{ minWidth: 200 }}><Typography variant="h5" color="textSecondary">New password:</Typography></Grid>
                                    <Grid item style={{ minWidth: 300 }}>
                                        <TextField variant='outlined' size='small' fullWidth type='password' value={newPassword} error={missing['newPassword']} onChange={(event) => setNewPassword(event.target.value)} />
                                    </Grid>
                                    {
                                        resetStatus === 2 ? (
                                            <React.Fragment>
                                                <Grid item><CircularProgress size={25} /></Grid>
                                                <Grid item>
                                                    <Typography variant='h5' color='textSecondary'>Encrypting...</Typography>
                                                </Grid>
                                            </React.Fragment>
                                        ) : resetStatus > 2 ? (
                                            <React.Fragment>
                                                <Grid item><DoneIcon color='primary' /></Grid>
                                                <Grid item>
                                                    <Typography variant='h5' color='textSecondary'>Encrypted</Typography>
                                                </Grid>
                                            </React.Fragment>
                                        ) : null
                                    }
                                </Grid>
                            </Grid>
                            <Grid item>
                                <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={1}>
                                    <Grid item style={{ minWidth: 200 }}><Typography variant="h5" color="textSecondary">Re enter password:</Typography></Grid>
                                    <Grid item style={{ minWidth: 300 }}>
                                        <TextField variant='outlined' size='small' fullWidth type='password' value={repassword} error={missing['repassword'] || passwordmatch === 0} onChange={(event) => setRepassword(event.target.value)} />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item><Button className={responsive.isDesktopOrLaptop ? classes.rootDesktop : responsive.isTablet ? classes.rootTablet : responsive.isMobile ? classes.rootMobile : classes.rootDesktop} variant='contained' disabled={resetStatus > 0 && resetStatus < 4} color='primary' onClick={onPaswordReset}><Typography variant='h5' color='textSecondary'>{resetStatus === -1 ? 'Retry' : 'Reset Password'}</Typography></Button></Grid>
                            {
                                resetStatus === 3 ? (
                                    <React.Fragment>
                                        <Grid item style={{ marginLeft: 35 }}><CircularProgress size={25} /></Grid>
                                        <Grid item>
                                            <Typography variant='h5' color='textSecondary'>Resetting your password</Typography>
                                        </Grid>
                                    </React.Fragment>
                                ) : resetStatus === 4 ? (
                                    <React.Fragment>
                                        <Grid item style={{ marginLeft: 35 }}><DoneIcon color='primary' /></Grid>
                                        <Grid item>
                                            <Typography variant='h5' color='textSecondary'>Password resetting complete</Typography>
                                        </Grid>
                                    </React.Fragment>
                                ) : resetStatus === -1 ? (
                                    <React.Fragment>
                                        <Grid item style={{ marginLeft: 35 }}><ErrorIcon color='secondary' /></Grid>
                                        <Grid item>
                                            <Typography variant='h5' color='textSecondary'>Password reset Failed</Typography>
                                        </Grid>
                                    </React.Fragment>
                                ) : null
                            }
                        </React.Fragment>
                    ) : (
                        <Grid container className={classes.root2} direction="column" justify="flex-start" alignItems="flex-start" spacing={1}>
                            <Grid item>
                                <Grid container direction="row" justify="center" alignItems="center" spacing={2}>
                                    <Grid item style={{ minWidth: 200 }}><Typography variant="h4" color="textSecondary">Current password:</Typography></Grid>
                                    <Grid item style={{ minWidth: 300 }}>
                                        <TextField variant='outlined' size='small' fullWidth type='password' value={currentPassword} error={missing['currentPassword']} onChange={(event) => setCurrentPassword(event.target.value)} />
                                    </Grid>
                                    {
                                        resetStatus === 1 ? (
                                            <React.Fragment>
                                                <Grid item><CircularProgress size={25} /></Grid>
                                                <Grid item>
                                                    <Typography variant='h5' color='textSecondary'>Encrypting...</Typography>
                                                </Grid>
                                            </React.Fragment>
                                        ) : resetStatus > 1 ? (
                                            <React.Fragment>
                                                <Grid item><DoneIcon color='primary' /></Grid>
                                                <Grid item>
                                                    <Typography variant='h5' color='textSecondary'>Encrypted</Typography>
                                                </Grid>
                                            </React.Fragment>
                                        ) : null
                                    }
                                </Grid>
                            </Grid>
                            <Grid item>
                                <Grid container direction="row" justify="center" alignItems="center" spacing={2}>
                                    <Grid item style={{ minWidth: 200 }}><Typography variant="h4" color="textSecondary">New password:</Typography></Grid>
                                    <Grid item style={{ minWidth: 300 }}>
                                        <TextField variant='outlined' size='small' fullWidth type='password' value={newPassword} error={missing['newPassword']} onChange={(event) => setNewPassword(event.target.value)} />
                                    </Grid>
                                    {
                                        resetStatus === 2 ? (
                                            <React.Fragment>
                                                <Grid item><CircularProgress size={25} /></Grid>
                                                <Grid item>
                                                    <Typography variant='h5' color='textSecondary'>Encrypting...</Typography>
                                                </Grid>
                                            </React.Fragment>
                                        ) : resetStatus > 2 ? (
                                            <React.Fragment>
                                                <Grid item><DoneIcon color='primary' /></Grid>
                                                <Grid item>
                                                    <Typography variant='h5' color='textSecondary'>Encrypted</Typography>
                                                </Grid>
                                            </React.Fragment>
                                        ) : null
                                    }
                                </Grid>
                            </Grid>
                            <Grid item>
                                <Grid container direction="row" justify="center" alignItems="center" spacing={2}>
                                    <Grid item style={{ minWidth: 200 }}><Typography variant="h4" color="textSecondary">Re enter password:</Typography></Grid>
                                    <Grid item style={{ minWidth: 300 }}>
                                        <TextField variant='outlined' size='small' fullWidth type='password' value={repassword} error={missing['repassword'] || passwordmatch === 0} onChange={(event) => setRepassword(event.target.value)} />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item>
                                <Grid container direction="row" justify="center" alignItems="center" spacing={2}>
                                    <Grid item><Button className={classes.button} variant='contained' disabled={resetStatus > 0 && resetStatus < 4} color='primary' onClick={onPaswordReset}><Typography variant='h5' color='textSecondary'>
                                        {
                                            resetStatus === -1 ? 'Retry' : 'Reset Password'
                                        }
                                    </Typography></Button></Grid>
                                    {
                                        resetStatus === 3 ? (
                                            <React.Fragment>
                                                <Grid item style={{ marginLeft: 35 }}><CircularProgress size={25} /></Grid>
                                                <Grid item>
                                                    <Typography variant='h5' color='textSecondary'>Resetting your password</Typography>
                                                </Grid>
                                            </React.Fragment>
                                        ) : resetStatus === 4 ? (
                                            <React.Fragment>
                                                <Grid item style={{ marginLeft: 35 }}><DoneIcon color='primary' /></Grid>
                                                <Grid item>
                                                    <Typography variant='h5' color='textSecondary'>Password resetting complete</Typography>
                                                </Grid>
                                            </React.Fragment>
                                        ) : resetStatus === -1 ? (
                                            <React.Fragment>
                                                <Grid item style={{ marginLeft: 35 }}><ErrorIcon color='secondary' /></Grid>
                                                <Grid item>
                                                    <Typography variant='h5' color='textSecondary'>Password reset Failed</Typography>
                                                </Grid>
                                            </React.Fragment>
                                        ) : null
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                    )
                }
            </Grid>
        </React.Fragment>
    )
}

export default ResetPassword
